import { render } from "./NewAcceptTermScreen.vue?vue&type=template&id=61e22468&scoped=true"
import script from "./NewAcceptTermScreen.vue?vue&type=script&lang=js"
export * from "./NewAcceptTermScreen.vue?vue&type=script&lang=js"

import "./NewAcceptTermScreen.vue?vue&type=style&index=0&id=61e22468&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61e22468"]])

export default __exports__